module.exports = __webpack_public_path__ + "static/githyanki-3c31341a7fae9063f96e7a406159c5f8.jpg";